import { createStore, applyMiddleware, type Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools/src/index.tsx';
import { defaultState } from '../default-state.tsx';
import rootEpic from '../epics/fetch-locations-data/index.tsx';
import type { State } from '../model.tsx';
import rootReducer from '../reducers/index.tsx';

const createStore1 = (initialState: State = defaultState) => {
	const store: Store<State> = createStore(
		rootReducer,
		initialState,
		composeWithDevtools({ name: 'LocationPicker' })(
			applyMiddleware(createEpicMiddleware(rootEpic)),
		),
	);
	return store;
};

export default createStore1;
